function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M99.91 48.038C93.856 25.444 70.632 12.036 48.04 18.09 25.444 24.144 12.036 47.368 18.09 69.962c6.055 22.594 29.278 36.002 51.872 29.948a42.286 42.286 0 0012.82-5.85 2.824 2.824 0 013.17 4.674 47.908 47.908 0 01-14.528 6.63c-25.607 6.862-51.927-8.334-58.788-33.94-6.861-25.607 8.335-51.927 33.941-58.788 25.606-6.862 51.927 8.334 58.788 33.94a47.803 47.803 0 01.008 24.847 2.824 2.824 0 01-5.454-1.466 42.141 42.141 0 00-.009-21.919z",
  fill: "#fff"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.875 42.82a2.714 2.714 0 11-5.429 0 2.714 2.714 0 015.429 0zM56.446 54.422a2.714 2.714 0 015.429 0v22.8a2.714 2.714 0 01-5.429 0v-22.8z",
  fill: "#fff"
});
function SvgInfoIconMb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "/img/InfoIcon-mb.svg";
export { SvgInfoIconMb as ReactComponent };